import { createStyles, Link, makeStyles, Theme } from '@material-ui/core';
import React from 'react';

import { ReactComponent as EmptyPlexesSvg } from '../../../../../assets/empty_plexes.svg';
import { colorPalette, spacings, TextSizesEnum } from '../../../../../theme';
import { PlexTypography } from '../../../../shared/primitives/PlexTypography';
import { useDialogState } from '../../../dialog/useDialogState';

export const EmptyTeamPlexesList = React.memo(
  (): React.ReactElement => {
    const classes = useStyles();
    const [, setDialogState] = useDialogState();
    const handleClickCreatePlex = (): void => {
      setDialogState({ type: 'new_plex' });
    };

    return (
      <div className={classes.root}>
        <EmptyPlexesSvg />
        <PlexTypography className={classes.title} text={"You don't have any Team Plexes"} size={TextSizesEnum.Small} />
        <PlexTypography className={classes.messageContainer} size={TextSizesEnum.Small}>
          <span className={classes.messageItem}>{'Click '}</span>
          <span className={classes.messageItem}>
            <Link className={classes.hereButton} onClick={handleClickCreatePlex} underline={'none'}>
              here
            </Link>
          </span>
          <span className={classes.messageItem}>{' to create'}</span>
        </PlexTypography>
      </div>
    );
  }
);

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      marginTop: 12,
      marginLeft: spacings.xxlarge,
      marginRight: spacings.xxlarge,
      marginBottom: spacings.normal,
      paddingLeft: spacings.xlarge,
      paddingRight: spacings.normal,
      paddingBottom: spacings.normal,
      paddingTop: spacings.small,
      borderRadius: 12,
      backgroundColor: colorPalette.purpleGray._50,
    },
    title: {
      marginTop: spacings.normal,
      color: colorPalette.purpleGray._400,
      fontWeight: 'bold',
    },
    messageContainer: {
      color: colorPalette.purpleGray._300,
      marginTop: 12,
      display: 'block',
    },
    messageItem: {
      display: 'inline',
    },
    hereButton: {
      cursor: 'pointer',
    },
  })
);
